<script>
import logoAcademic from "@/assets/logo-academic.png";
import logoCollapsed from "@/assets/logo-collapsed.png";
import rrdTextLogo from "@/assets/rrd-logo-text.png";
import rccLogo from "@/assets/rcc-logo-grey.png";
import euLogo from "@/assets/logo-eu.png";
import routerName from "@/router/routeNames";

export default {
  name: "PublicLeftSide",
  data() {
    return {
      logoAcademic,
      rrdTextLogo,
      logoCollapsed,
      rccLogo,
      euLogo,
      routerName,
      isHidden: false,
      isMobile: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      // Provera da li je ekran manji od 992px
      this.isMobile = window.innerWidth < 992;

      // Ako pređemo na mobile, automatski sakrij sidebar da ne smeta
      if (this.isMobile) {
        this.isHidden = true;
      } else {
        // Na desktopu vratimo na default (ili kako želiš)
        this.isHidden = false;
      }
    },
    togglePanel() {
      this.isHidden = !this.isHidden;
    },
    closeMobileMenu() {
      if (this.isMobile) {
        this.isHidden = true;
      }
    },
    onLogoClick() {
      if (this.isHidden) {
        this.togglePanel();
      } else {
        if (this.$route.name !== this.routerName.RN_PUBLIC_QUALIFICATION_DATA) {
          this.$router.push({ name: this.routerName.RN_PUBLIC_QUALIFICATION_DATA });
        }
        // Na mobilnom, klik na logo takođe može da zatvori meni ako je već na toj strani
        if (this.isMobile) this.closeMobileMenu();
      }
    },
  },
};
</script>

<template>
  <div>
    <button
      v-if="isHidden && isMobile"
      class="mobile-toggle-btn"
      @click="togglePanel"
    >
      <i class="fas fa-bars"></i>
    </button>

    <div
      class="sidebar-overlay"
      :class="{ 'show': !isHidden && isMobile }"
      @click="closeMobileMenu"
    ></div>

    <aside class="rrd-sidebar d-flex flex-column" :class="{ collapsed: isHidden }">
      <div class="sidebar-content">
        <div class="rrd-logo">
          <div class="d-flex align-items-start logo-container">
            <button
              class="rrd-logo-btn"
              type="button"
              @click="onLogoClick"
              :title="isHidden ? 'Expand sidebar' : ''"
              :aria-label="isHidden ? 'Expand sidebar' : 'RRD'"
            >
              <img :src="!isHidden ? logoAcademic : logoCollapsed" alt="RRD" class="rrd-logo-main-img" />
            </button>
            <img v-if="!isHidden" :src="rrdTextLogo" alt="RRD" class="rrd-logo-rrd-txt" />
          </div>
        </div>

        <div class="rrd-divider fade-element"></div>

        <nav class="rrd-nav">
          <router-link
            class="rrd-nav-link"
            :class="{ 'rrd-nav-active': $route.name === routerName.RN_PUBLIC_QUALIFICATION_DATA }"
            :to="{ name: routerName.RN_PUBLIC_QUALIFICATION_DATA }"
            @click.native="closeMobileMenu"
          >
            <i class="fas fa-database rrd-nav-icon" aria-hidden="true"></i>
            <span v-if="isHidden && !isMobile" class="rrd-tooltip">Database of Qualifications</span>
            <span v-if="!isHidden" class="rrd-nav-text fade-element">Database of Qualifications</span>
          </router-link>

          <router-link
            class="rrd-nav-link"
            :class="{ 'rrd-nav-active': $route.name === routerName.RN_PUBLIC_STATISTIC }"
            :to="{ name: routerName.RN_PUBLIC_STATISTIC }"
            @click.native="closeMobileMenu"
          >
            <i class="fas fa-chart-bar rrd-nav-icon" aria-hidden="true"></i>
            <span v-if="isHidden && !isMobile" class="rrd-tooltip">Statistics of Qualifications</span>
            <span v-if="!isHidden" class="rrd-nav-text fade-element">Statistics of Qualifications</span>
          </router-link>

          <router-link v-if="isHidden && !isMobile"
                       class="rrd-nav-link"
                       :class="{ 'rrd-nav-active': $route.name === routerName.RN_LOGIN }"
                       :to="{ name: routerName.RN_LOGIN }"
          >
            <i class="fas fa-sign-in-alt rrd-nav-icon" aria-hidden="true"></i>
            <span class="rrd-tooltip">Staff Login</span>
          </router-link>
        </nav>

        <div class="rrd-divider fade-element"></div>

        <div v-if="!isHidden" class="rrd-text fade-element">
          <p>
            The Regional Recognition Database (RRD) is a regional digital tool developed to support
            the implementation of the Agreement on the Recognition of Higher Education Qualifications
            in the Western Balkans Six (WB6).
          </p>
          <p>
            Its primary function is to facilitate the exchange and verification of information on
            recognised higher education institutions and qualifications among participating economies.
          </p>
        </div>

        <a
          v-if="!isHidden"
          href="https://www.rcc.int/pages/11/contact"
          target="_blank"
          rel="noopener"
          class="btn rrd-btn align-self-start fade-element"
        >
          CONTACT US <i class="arrow-icon fa fa-angle-right ms-2" aria-hidden="true" />
        </a>
        <div class="rrd-divider fade-element"></div>

        <div v-if="!isHidden" class="rrd-text fade-element">
          <p>
            This page is intended for use by the staff of the ENIC/NARIC centers in the Western
            Balkans Six (WB6) who are responsible for the recognition of academic qualifications.
          </p>
        </div>

        <router-link
          class="btn rrd-btn align-self-start fade-element"
          :class="{ 'rrd-btn-active': $route.name === routerName.RN_LOGIN }"
          :to="{ name: routerName.RN_LOGIN }"
          @click.native="closeMobileMenu"
        >
          <span style="margin-right: 2px" v-if="!isHidden">STAFF LOGIN</span>
          <span v-else class="sr-only">Staff login</span>
          <i class="arrow-icon fa fa-angle-right ms-2" aria-hidden="true" />
        </router-link>

      </div>
      <div class="rrd-sidebar-bottom mt-auto">
        <div v-if="!isHidden" class="rrd-divider my-3"></div>

        <div class="footer-row">
          <div v-if="!isHidden" class="footer-left">
            <img :src="rccLogo" alt="Powered by RCC.int" class="rrd-rcc-logo" />

            <div class="rrd-eu-block">
              <img :src="euLogo" alt="EU" class="rrd-eu-logo" />
            </div>
          </div>

          <button
            class="rrd-back-btn"
            :class="{ 'is-collapsed': isHidden, 'is-expanded': !isHidden }"
            type="button"
            @click="togglePanel"
            :aria-label="isHidden ? 'Expand sidebar' : 'Collapse sidebar'"
          >
            <i v-if="isMobile && !isHidden" class="fas fa-times"></i>
            <i v-else :class="['fas', isHidden ? 'fa-angle-right' : 'fa-angle-left']"></i>
          </button>
        </div>
      </div>
    </aside>
  </div>
</template>
